module.exports = __webpack_public_path__ + "img/light-on.27e6802e.svg";